// 공용 상수 정의
export const STORAGE_KEYS = {
  ACCESS_TOKEN: "qbox_access_token",
  REFRESH_TOKEN: "qbox_refresh_token",
  USER_INFO: "qbox_user_info",
} as const;

// 환경 변수에서 API Base URL 가져오기
export const API_PREFIX = import.meta.env.VITE_API_BASE_URL || "/api/v2/admin";
